// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8701) return "static/chunks/8701-19c247afe4ba5920.js";
	if (chunkId === 3032) return "static/chunks/3032-80866fa2f92582d0.js";
	if (chunkId === 1810) return "static/chunks/1810-deef4607976e168e.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"1325":"210f6791","2222":"4e9979e5","6441":"539845e3"}[chunkId] || chunkId) + "." + {"946":"1f6559ed57c1651f","1325":"eb938705578aab20","1809":"07b156cd6461713d","2222":"00751cb0fc50539d","5012":"4b18525183f41c6f","6441":"f45d963eff349341"}[chunkId] + ".js";
};